import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog} from '@angular/material/dialog';
import {
    InsuranceManageSubscribersComponent
} from '../../../insurance/insurance-manage-subscribers/insurance-manage-subscribers.component';
import {PatientDataModel} from '../../../../models/patient/patient-data.model';

@Component({
  standalone: false,
    selector: 'app-ar-payment-token-consent',
    templateUrl: './ar-payment-token-consent.component.html',
    styleUrls: ['./ar-payment-token-consent.component.scss']
})
export class ArPaymentTokenConsentComponent implements OnInit{

    isLoading: boolean = true;
    verbalConsent: boolean = false;
    consentGivenBy: string = 'patient'; // Default selection
    expirationDate: string = '';
    paymentAmount: number ;
    patientContactID: string;
    patientContactName: string;
    dataPatient: PatientDataModel;
    patientId: string;
    // The location's surcharge rate, or 0 when surcharging is off; when on, staff confirm they told the patient.
    surchargeRate: number = 0;
    isSurchargeAcknowledged: boolean = false;

    constructor(
        private readonly dialog: MatDialog,
        public dialogRef: MatDialogRef<ArPaymentTokenConsentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {

    }

    async ngOnInit() {
        this.isLoading = false;
        this.paymentAmount = this.data.amount;
        this.dataPatient = this.data.patient;
        this.patientId = this.data.patientId;
        this.surchargeRate = this.data.surchargeRate ?? 0;
    }

    close() {
        this.dialogRef.close('close');
    }

    chargePaymentButton(){
        this.isLoading = true;
        const result = [this.expirationDate];

        if (this.consentGivenBy === 'patientContact'){
            result.push(this.patientContactID);
        }
        else
            result.push(this.dataPatient.ContactId);
        this.dialogRef.close(result);
        // probably put expiration in there and contact id
    }

    formatExpiryDate(event: any) {
        const input = event.target.value.replace(/\D/g, '');
        let formattedDate = '';
        if (input.length >= 2) {
            formattedDate = input.slice(0, 2) + '-';
        }
        if (input.length > 2) {
            formattedDate += input.slice(2, 6);
        }
        this.expirationDate = formattedDate;
    }

    //
    launchSubscriberManager() {
        const config = new MatDialogConfig();
        config.width = '800px';
        config.height = '550px';
        config.data = {
            currentPatientId: this.patientId,
            currentPatient: this.dataPatient,
            contactSelect: true
        };
        config.panelClass = 'dialog';

        const dialogRef = this.dialog.open(InsuranceManageSubscribersComponent, config);
        dialogRef.afterClosed().subscribe(
            result => {
                if (result){
                    console.log(result);
                    this.patientContactID = result[0];
                    this.patientContactName = result[1];
                    this.patientContactName += ' ' + result[2];
                    this.consentGivenBy = 'patientContact';
                }
            },
            err => {
                console.log(err);
            }
        );

    }

}
